import { combineReducers } from '@reduxjs/toolkit';
import chat from '../components/chat/store/chat.slice';
import financialFilter from '../components/financialFilter/store/financial.filter.slice';
import select from '../components/selectOblect/state/slice';
import actions from '../screens/actionList/store/action.slice';
import auth from '../screens/auth/store/auth.slice';
import camera from '../screens/camera/store/camera.slice';
import courier from '../screens/courier/store/courier.slice';
import video from '../screens/externalСamera/store/externalVideo.slice';
import financial from '../screens/financial/store/financial.slice';
import financialMenu from '../screens/finOrders/state/financial.slice';
import inventory from '../screens/inventory/store/inventory.slice';
import loyalty from '../screens/loyalty/store/loyalty.slice';
import monitor from '../screens/monitoring/store/monitoring.slice';
import order from '../screens/monitoringOrder/store/order.slice';
import call from '../screens/phoneCall/store/call.slice';
import photoReport from '../screens/photoReport/store/photoReport.slice';
import product from '../screens/products/store/product.slice';
import purchase from '../screens/purchase/store/slice';
import quiz from '../screens/quiz/store/quiz.slice';
import report from '../screens/report/store/report.slice';
import reviews from '../screens/reviews/store/review.slice';
import employee from '../screens/selectEmployee/store/employee.slice';
import table from '../screens/tableView/store/table.slice';
import taskSwitch from '../screens/taskCreate/store/task.slice';
import taskMenu from '../screens/taskTypes/store/taskTypes.slice';
import timeControl from '../screens/timeControl/store/timeControl.slice';
import analitic from '../screens/videoStreams/store/slice';
import waiters from '../screens/waiters/store/waiters.slice';
import { api, apiAI, apiAIAssistant, apiArchive, apiCourier, apiEvotor, apiPush, apiStreamServer } from './api';
import app from './app.slice';

export const rootReducer = combineReducers({
  auth,
  app,
  quiz,
  camera,
  taskMenu,
  financialMenu,
  financialFilter,
  chat,
  report,
  taskSwitch,
  inventory,
  actions,
  photoReport,
  employee,
  call,
  table,
  monitor,
  order,
  timeControl,
  reviews,
  courier,
  loyalty,
  product,
  financial,
  select,
  purchase,
  video,
  waiters,
  analitic,
  [apiPush.reducerPath]: apiPush.reducer,
  [api.reducerPath]: api.reducer,
  [apiAI.reducerPath]: apiAI.reducer,
  [apiAIAssistant.reducerPath]: apiAIAssistant.reducer,
  [apiCourier.reducerPath]: apiCourier.reducer,
  [apiStreamServer.reducerPath]: apiStreamServer.reducer,
  [apiArchive.reducerPath]: apiArchive.reducer,
  [apiEvotor.reducerPath]: apiEvotor.reducer,
});
